// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from tag-alt-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function TagAltFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5 3a5 5 0 1 1 0 10A5 5 0 0 1 5 3Zm6 0a5 5 0 0 1 0 10 1 1 0 0 1-.117-1.993L11 11a3 3 0 0 0 0-6 1 1 0 0 1 0-2Z"
      />
    </svg>
  );
}
